import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import EventRegularItemComponent from './event_regular_item_component'
import EventCondensedItemComponent from './event_condensed_item_component'
import { useEffect, useRef } from 'react'

const EventsListComponent = (props) => {

  const prevPropsRef = useRef(props)

  // document.body.style.overflow = 'hidden'

  useEffect(() => {
    const prevProps = prevPropsRef.current
    if (prevProps.dataIsLoading && !props.dataIsLoading) {
      // Prevent scrolling if you are in a Multi Widget page
      let fromMultiWidgets = false
      // Check if the element is in an iframe and if the iframe's id contains `widget`
      if (window.frameElement && window.frameElement.id.search('widget') === 0) {
        fromMultiWidgets = true
      }
      if (!fromMultiWidgets) {
        setTimeout(() => {
          try {
            window.parent.scroll(0, props.scrollPosition)
          } catch (err) {
            // 1 == 1
          }
        }, 0)
      }
    }
  }, [ props.dataIsLoading, props.scrollPosition ])

  const itemExtraProps = {
    addToCart: props.addToCart,
    idsForLabels: props.idsForLabels,
    cartMerchantAccountId: props.cartMerchantAccountId,
    cartMerchantAccountType: props.cartMerchantAccountType,
    statusFilter: props.statusFilter,
    showCourseInfo: props.showCourseInfo,
    directoryHideGolfers: props.directoryHideGolfers,
    shouldSort: props.shouldSort,
    shouldHideRegistration: props.shouldHideRegistration,
  }

  let width = window.innerWidth
  try {
    width = window.parent.innerWidth
  } catch (err) {
    // 1 == 1
  }

  const eventListItemComponent = (league) => { // TODO: CHECK IF THIS IS RIGHT
    if (window.glg.new_design_shared.isMobile() || width < 992) {
      return(
        <EventCondensedItemComponent {...league} {...itemExtraProps}></EventCondensedItemComponent>
      )
    }
    else if(props.viewType === 'regular') {
      return(
        <EventRegularItemComponent {...league} {...itemExtraProps}></EventRegularItemComponent>
      )
    }
    else {
      return(
        <EventCondensedItemComponent {...league} {...itemExtraProps}></EventCondensedItemComponent>
      )
    }
  }

  return (
    <>
      {!props.dataIsLoading && Object.keys(props.leagues).length === 0 && (
        <p className="text-center">
          { !window.I18n ? '' : window.I18n.t('customer_directories.no_events') }
        </p>
      )}
      {Object.keys(props.leagues).length > 0 && (
        <div className='add-margin-top-10'>
          {props.sortedLeagueIds !== undefined
            ? props.sortedLeagueIds.map((leagueId) => {
                if (props.leagues[leagueId] === undefined) {
                  return null
                }
                return eventListItemComponent(props.leagues[leagueId])
              })
            : Object.keys(props.leagues).map((leagueId) => {
                if (props.leagues[leagueId] === undefined) {
                  return null
                }
                return eventListItemComponent(props.leagues[leagueId])
              })}
        </div>
      )}
    </>
  )
}

EventsListComponent.propTypes = {
  viewType: PropTypes.string,
  leagues: PropTypes.object,
  addToCart: PropTypes.func,
  idsForLabels: PropTypes.object,
  cartMerchantAccountId: PropTypes.string,
  cartMerchantAccountType: PropTypes.string,
  statusFilter: PropTypes.array,
  dataIsLoading: PropTypes.bool,
  scrollPosition: PropTypes.number,
  showCourseInfo: PropTypes.bool,
  directoryHideGolfers: PropTypes.bool,
  shouldSort: PropTypes.bool,
  shouldHideRegistration: PropTypes.bool,
  fetchMoreData: PropTypes.func,
  sortedLeagueIds: PropTypes.array,
}

export default EventsListComponent